import React from 'react';
import { FaEnvelope, FaGlobeEurope, FaPhoneAlt } from 'react-icons/fa';
import styles from './Section3.module.css';

type Icon = React.FC<{ 'aria-hidden'?: string }>;
const GlobeIcon = FaGlobeEurope as unknown as Icon;
const PhoneIcon = FaPhoneAlt as unknown as Icon;
const MailIcon = FaEnvelope as unknown as Icon;

const Section3: React.FC = () => (
  <section id="section3" className={styles.section}>
    <div className={styles.content}>
      <div className={styles.heading}>
        <p>Контакти</p>
        <h2>Нека започнем с разговор.</h2>
        <span>Изпратете запитване или се свържете с нас директно.</span>
      </div>
      <div className={styles.contactGrid}>
        <div className={styles.contactCard}><PhoneIcon aria-hidden="true" /><span>Телефони</span><a href="tel:+359883354449"><strong>+359 883 354 449</strong></a><a href="tel:+359899271495"><strong>+359 899 271 495</strong></a></div>
        <a href="mailto:office@geoworld.bg" className={styles.contactCard}><MailIcon aria-hidden="true" /><span>Електронна поща</span><strong>office@geoworld.bg</strong></a>
        <div className={styles.contactCard}><GlobeIcon aria-hidden="true" /><span>Обхват</span><strong>Геодезически услуги в цяла България</strong></div>
      </div>
    </div>
  </section>
);

export default Section3;
